import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import ZakatAktivasi from './ZakatAktivasi';
import ZakatDashboardPane from './ZakatDashboardPane';
import ZakatMuzakkiPane from './ZakatMuzakkiPane';
import ZakatTransaksiPane from './ZakatTransaksiPane';
import ZakatRiwayatPane from './ZakatRiwayatPane';
import ZakatLaporanPane from './ZakatLaporanPane';
import ZakatPengaturanPane from './ZakatPengaturanPane';
import { LayoutDashboard, Users, CreditCard, History, FileText, Settings2, Wheat } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const cfg = { withCredentials: true };

const SUBMENU = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'muzakki', label: 'Data Muzakki', icon: Users },
  { id: 'transaksi', label: 'Bayar Zakat Fitrah', icon: CreditCard },
  { id: 'riwayat', label: 'Riwayat Pembayaran', icon: History },
  { id: 'laporan', label: 'Laporan', icon: FileText },
  { id: 'pengaturan', label: 'Pengaturan', icon: Settings2 },
];

export default function ZakatRamadanManager() {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeMenu, setActiveMenu] = useState('dashboard');

  const loadProfile = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/zakat-ramadan/profile`, cfg);
      setProfile(data);
    } catch {
      setProfile({ exists: false });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadProfile(); }, [user?.mosque_id]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="w-8 h-8 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!profile?.exists) {
    return <ZakatAktivasi onActivated={loadProfile} />;
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-emerald-700 flex items-center justify-center">
          <Wheat className="w-5 h-5 text-white" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-bold text-primary-dark">Zakat Ramadan</h2>
          <p className="text-xs text-stone-500">{profile.entity_name || ''}</p>
        </div>
      </div>

      {/* Sub-navigation */}
      <div className="bg-white rounded-2xl border border-stone-200 p-2 flex gap-1.5 overflow-x-auto">
        {SUBMENU.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            data-testid={`zakat-menu-${id}`}
            onClick={() => setActiveMenu(id)}
            className={`flex items-center gap-2 px-3 py-2 rounded-xl font-body font-medium text-xs transition-colors whitespace-nowrap ${
              activeMenu === id
                ? 'bg-emerald-700 text-white'
                : 'text-stone-600 hover:bg-stone-50'
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </button>
        ))}
      </div>

      {/* Content */}
      {activeMenu === 'dashboard' && <ZakatDashboardPane profile={profile} />}
      {activeMenu === 'muzakki' && <ZakatMuzakkiPane mosqueId={user?.mosque_id} />}
      {activeMenu === 'transaksi' && <ZakatTransaksiPane profile={profile} mosqueId={user?.mosque_id} />}
      {activeMenu === 'riwayat' && <ZakatRiwayatPane mosqueId={user?.mosque_id} />}
      {activeMenu === 'laporan' && <ZakatLaporanPane mosqueId={user?.mosque_id} profile={profile} />}
      {activeMenu === 'pengaturan' && <ZakatPengaturanPane profile={profile} onSaved={loadProfile} />}
    </div>
  );
}
